import { css } from "@emotion/react"

export const dropListItemStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const dropLabelStyle = css`
  display: inline-block;
  height: 100%;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
